import Enum from '@square/dashboard-utilities/utils/enum';
import InstrumentSummary from '@square/dashboard-data/models/squareup/simple-instrument-store/api/instrument-summary';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
const Status = new Enum(['INVALID_STATUS', 'SUCCESS',
// TODO: Remove once Instruments no longer sends this enum
'FAILED', 'GENERIC_FAILURE', 'POSTAL_CODE_INVALID', 'CARD_NOT_SUPPORTED']);
export default ProtoBaseModel.extend({
  status: attr(Status),
  instrument: attr(InstrumentSummary)
}).reopenClass({
  Status
});